import { render, staticRenderFns } from "./boxperfil.vue?vue&type=template&id=7e0c23f6&scoped=true"
import script from "./boxperfil.vue?vue&type=script&lang=js"
export * from "./boxperfil.vue?vue&type=script&lang=js"
import style0 from "./boxperfil.vue?vue&type=style&index=0&id=7e0c23f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0c23f6",
  null
  
)

export default component.exports